/**
 * The popular models, for prominence only: /models shows them first as cards, every other registry model in the
 * "All models" list below. Every registry model has a page (registry.ts). Order is the /models grid's order: Jev and its best-known look-alikes, frontier LLMs, then well-known open models.
 * A test fails when an id here is not in the registry or has no non-internal result.
 */
export const CURATED: readonly string[] = [
  // Jev, and the Jev-likes people know
  'jev',
  'eikos-27b',
  'autojev-27b',
  'pplx-decider-v1.1-27b',
  'mercury-decide',
  'microsoft-decision-1',
  'h2o-lightning-4b',
  'quyet-1.0-large',
  'decisio-v0.8.0',
  'deck31b',
  'rene-1-31b-fp8',
  // frontier LLMs (no Mistral Large or gpt-oss in any export yet)
  'claude-opus-5-5',
  'claude-sonnet-5-5',
  'claude-haiku-5-5',
  'claude-haiku-4-5',
  'gpt-6.1-sol',
  'gpt-6-luna',
  'openai-decisions',
  'gpt-5.6-terra',
  'gemini-3.8-flash',
  'gemini-4-argon',
  // well-known open models
  'gemma-4-31b',
  'gemma-4-26b-a4b',
  'gemma-4-12b',
  'qwen3.8-27b',
  'qwen3.6-35b-a3b',
  'qwen3.5-9b',
  'llama-3.2-3b-instruct',
  'ministral-3-14b',
  'granite-4.2-8b',
  'phi-4-mini-instruct',
]
